"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFilledUserPhotoLayer = exports.filledUserPhotoLayerRuleSet = exports.isUserPhotoLayerUserData = exports.userPhotoLayerUserDataRuleSet = exports.isUserPhotoLayer = exports.userPhotoLayerRuleSet = exports.isImageModifications = exports.isDefaultModifications = exports.isPinturaModifications = exports.isCrop = exports.isSize = void 0;
exports.userPhotoLayerHasDefaultMods = userPhotoLayerHasDefaultMods;
exports.isUserPhotoLayerUserDataValid = isUserPhotoLayerUserDataValid;
exports.getUserPhotoUrlForLayer = getUserPhotoUrlForLayer;
exports.getOriginalUserPhotoUrlForLayer = getOriginalUserPhotoUrlForLayer;
exports.generateProjectImageId = generateProjectImageId;
exports.getModifiedImageS3Key = getModifiedImageS3Key;
exports.getGalleryImageS3Key = getGalleryImageS3Key;
exports.getModifiedImageUrlForLayer = getModifiedImageUrlForLayer;
exports.isSimpleCrop = isSimpleCrop;
exports.usesProjectImage = usesProjectImage;
exports.clearUserPhotoLayer = clearUserPhotoLayer;
const typeguard_1 = require("./../../types/typeguard");
const GalleryImage_1 = require("../GalleryImage");
const typeguard_2 = require("../../types/typeguard");
const env_1 = require("../../utils/env");
const Layer_1 = require("./Layer");
const md5_1 = __importDefault(require("crypto-js/md5"));
const sizeRuleSet = {
  width: typeguard_2.isNumber,
  height: typeguard_2.isNumber
};
const isSize = s => (0, typeguard_2.isType)(s, sizeRuleSet);
exports.isSize = isSize;
const cropRuleSet = Object.assign(Object.assign({}, sizeRuleSet), {
  x: typeguard_2.isNumber,
  y: typeguard_2.isNumber
});
const isCrop = c => (0, typeguard_2.isType)(c, cropRuleSet);
exports.isCrop = isCrop;
const pinturaModificationsRuleSet = {
  schemaVersion: typeguard_1.isNonEmptyString,
  cropLimitToImage: (0, typeguard_2.optional)(typeguard_2.isBool),
  cropMinSize: (0, typeguard_2.optional)(exports.isSize),
  cropMaxSize: (0, typeguard_2.optional)(exports.isSize),
  cropAspectRatio: (0, typeguard_2.optional)(typeguard_2.isNumber),
  flipX: (0, typeguard_2.optional)(typeguard_2.isBool),
  flipY: (0, typeguard_2.optional)(typeguard_2.isBool),
  rotation: (0, typeguard_2.optional)(typeguard_2.isNumber),
  crop: (0, typeguard_2.optional)(exports.isCrop)
};
const isPinturaModifications = p => (0, typeguard_2.isType)(p, pinturaModificationsRuleSet);
exports.isPinturaModifications = isPinturaModifications;
const defaultModificationsRuleSet = {
  defaultCrop: exports.isCrop
};
const isDefaultModifications = d => (0, typeguard_2.isType)(d, defaultModificationsRuleSet);
exports.isDefaultModifications = isDefaultModifications;
const isImageModifications = m => (0, exports.isDefaultModifications)(m) || (0, exports.isPinturaModifications)(m);
exports.isImageModifications = isImageModifications;
exports.userPhotoLayerRuleSet = {
  type: value => !!value && value === 'user_photo'
};
const isUserPhotoLayer = l => (0, Layer_1.isLayer)(l) && (0, typeguard_2.isType)(l, exports.userPhotoLayerRuleSet);
exports.isUserPhotoLayer = isUserPhotoLayer;
exports.userPhotoLayerUserDataRuleSet = {
  galleryId: typeguard_1.isNonEmptyString,
  galleryImageId: typeguard_1.isNonEmptyString,
  projectImageId: (0, typeguard_2.optional)(typeguard_1.isNonEmptyString),
  imageData: (0, typeguard_2.optional)(exports.isSize),
  modifications: exports.isImageModifications
};
const isUserPhotoLayerUserData = u => (0, typeguard_2.isType)(u, exports.userPhotoLayerUserDataRuleSet);
exports.isUserPhotoLayerUserData = isUserPhotoLayerUserData;
exports.filledUserPhotoLayerRuleSet = Object.assign(Object.assign({}, exports.userPhotoLayerRuleSet), {
  userData: exports.isUserPhotoLayerUserData
});
const isFilledUserPhotoLayer = l => (0, Layer_1.isLayer)(l) && (0, typeguard_2.isType)(l, exports.filledUserPhotoLayerRuleSet);
exports.isFilledUserPhotoLayer = isFilledUserPhotoLayer;
function userPhotoLayerHasDefaultMods(layer) {
  var _a;
  return (0, exports.isDefaultModifications)((_a = layer.userData) === null || _a === void 0 ? void 0 : _a.modifications);
}
function isUserPhotoLayerUserDataValid(userData) {
  var _a, _b, _c, _d;
  if (!userData.imageData || !(0, exports.isPinturaModifications)(userData.modifications)) {
    return false;
  }
  const rotationInDegrees = Math.floor(Math.abs((userData.modifications.rotation || 0) * 180 / Math.PI));
  if (rotationInDegrees && rotationInDegrees % 90 !== 0) {
    // We are explicitly not handling crop bound calculation checks on custom rotations because it involves a lot of math and
    // the edge case is small enough for the time being that it's not worth the effort to account for it.
    return true;
  }
  // Assume 0, 180, or 360 degree rotation
  let imageWidth = userData.imageData.width;
  let imageHeight = userData.imageData.height;
  // If rotation is 90 or 270 degrees flip width and height
  if (rotationInDegrees % 90 === 0 && rotationInDegrees % 180 !== 0) {
    imageWidth = userData.imageData.height;
    imageHeight = userData.imageData.width;
  }
  const inBoundsX = (((_a = userData.modifications.crop) === null || _a === void 0 ? void 0 : _a.x) || 0) + (((_b = userData.modifications.crop) === null || _b === void 0 ? void 0 : _b.width) || 0) <= imageWidth;
  const inBoundsY = (((_c = userData.modifications.crop) === null || _c === void 0 ? void 0 : _c.y) || 0) + (((_d = userData.modifications.crop) === null || _d === void 0 ? void 0 : _d.height) || 0) <= imageHeight;
  return inBoundsX && inBoundsY;
}
function getUserPhotoUrlForLayer(flashId, layer) {
  let size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1200';
  if (!layer.userData) {
    return undefined;
  }
  const s3BaseUrl = (0, env_1.getS3ImageBaseUrl)();
  if (!s3BaseUrl) {
    console.warn('s3BaseUrl not defined');
    return undefined;
  }
  return `${s3BaseUrl.value}/${flashId}/${layer.userData.galleryImageId}_${size === 'original' ? 'autoOriented' : size}`;
}
function getOriginalUserPhotoUrlForLayer(flashId, layerUserData) {
  let suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : GalleryImage_1.ORIGINAL_SUFFIX;
  if (!layerUserData) {
    return undefined;
  }
  const s3BaseUrl = (0, env_1.getS3ImageBaseUrl)();
  if (!s3BaseUrl) {
    console.warn('s3BaseUrl not defined');
    return undefined;
  }
  return `${s3BaseUrl.value}/${flashId}/${layerUserData.galleryImageId}${suffix ? `${suffix}` : ''}`;
}
function generateProjectImageId(projectImageInfo) {
  let pii = projectImageInfo;
  if ((0, exports.isPinturaModifications)(pii.modifications)) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _a = pii.modifications,
      {
        crop,
        rotation,
        cropAspectRatio
      } = _a,
      modsWithoutCropOrRotation = __rest(_a, ["crop", "rotation", "cropAspectRatio"]);
    // We have to include unique values for flipX and flipY because if we just hash the true/false values,
    // the hash will be the same for both {flipX: true, flipY: false} and {flipX: false, flipY: true}
    pii = Object.assign(Object.assign(Object.assign(Object.assign({}, pii), {
      modifications: modsWithoutCropOrRotation
    }), modsWithoutCropOrRotation.flipX && {
      flipX: 'flipX'
    }), modsWithoutCropOrRotation.flipY && {
      flipX: 'flipY'
    });
  }
  return `${(0, md5_1.default)(JSON.stringify(pii).split('').sort().join(''))}`;
}
function getModifiedImageS3Key(flashId, layerUserData) {
  let size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '_1200';
  return `${flashId}/${layerUserData.galleryImageId}/${layerUserData.projectImageId || generateProjectImageId(layerUserData)}${size}`;
}
function getGalleryImageS3Key(flashId, layerUserData) {
  let size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '_1200';
  return `${flashId}/${layerUserData.galleryImageId}${size === '_1200' ? '_1200' : '_original'}`;
}
function getModifiedImageUrlForLayer(flashId, layerUserData) {
  let size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '_1200';
  const s3BaseUrl = (0, env_1.getS3ImageBaseUrl)();
  if (!s3BaseUrl) {
    console.warn('s3BaseUrl not defined');
    throw new Error('Missing required information to form image path');
  }
  const imagePath = usesProjectImage(layerUserData) ? getModifiedImageS3Key(flashId, layerUserData, size) : getGalleryImageS3Key(flashId, layerUserData, size);
  return `${s3BaseUrl.value}/${imagePath}`;
}
function isSimpleCrop(mods) {
  var _a, _b, _c, _d;
  return !mods.flipX && !mods.flipY && !mods.colorMatrix && !mods.convolutionMatrix && !mods.gamma && !mods.vignette && !!mods.schemaVersion && (0, typeguard_2.isNumber)(mods.cropAspectRatio) && (0, typeguard_2.isNumber)(mods.rotation) && (0, typeguard_2.isNumber)((_a = mods.crop) === null || _a === void 0 ? void 0 : _a.x) && (0, typeguard_2.isNumber)((_b = mods.crop) === null || _b === void 0 ? void 0 : _b.y) && (0, typeguard_2.isNumber)((_c = mods.crop) === null || _c === void 0 ? void 0 : _c.width) && (0, typeguard_2.isNumber)((_d = mods.crop) === null || _d === void 0 ? void 0 : _d.height);
}
function usesProjectImage(layerUserData) {
  return (0, exports.isDefaultModifications)(layerUserData.modifications) || !isSimpleCrop(layerUserData.modifications);
}
function clearUserPhotoLayer(layer) {
  return Object.assign(Object.assign({}, layer), {
    userData: undefined
  });
}